module.exports = __webpack_public_path__ + "img/flag_en.dfaac705.jpg";